module.exports = __webpack_public_path__ + "img/IMG_6442 1.bc4724ea.webp";